import { Overlays } from '../overlays/overlay';
import { AbstractRendererImpl } from '../abstract_renderer';

export class ServerOverlays extends Overlays {
  constructor(_renderer: AbstractRendererImpl) {
    super(_renderer);
  }
}
